import { render, staticRenderFns } from "./assetsEnter.vue?vue&type=template&id=08d93620&scoped=true"
import script from "./assetsEnter.vue?vue&type=script&lang=js"
export * from "./assetsEnter.vue?vue&type=script&lang=js"
import style0 from "./assetsEnter.vue?vue&type=style&index=0&id=08d93620&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08d93620",
  null
  
)

export default component.exports